"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = build;
// @ts-nocheck
const utilities_1 = require("./includes/utilities");
function assignByKeys(targetArray, sourceArray, keys) {
  sourceArray.forEach(source => {
    const target = targetArray.find(item => keys.every(key => item[key] === source[key]));
    if (target) {
      Object.assign(target, source);
    } else {
      targetArray.push(source);
    }
  });
}
function processKey(dataLayer, name, value, merge = false) {
  if (!Array.isArray(dataLayer.var_in_conflict)) {
    dataLayer.var_in_conflict = [];
  }
  if (merge) {
    if (dataLayer[name] !== undefined && !Array.isArray(dataLayer[name])) {
      dataLayer.var_in_conflict.push({
        keyName: name,
        keyValue: value,
        keyMerge: merge
      });
      return;
    }
    if (!dataLayer[name]) {
      // If the property doesn't exists, initialize it
      dataLayer[name] = [];
    }
    if (merge === true) {
      // If there is no merge "key", push the value
      dataLayer[name].push(...value);
      return;
    }
    // If there are merge keys, merge each item by their keys
    assignByKeys(dataLayer[name], value, merge);
    return;
  }
  if (dataLayer[name]) {
    // If the property already exists, we have a conflict
    dataLayer.var_in_conflict.push({
      keyName: name,
      keyValue: value,
      keyMerge: merge
    });
    return;
  }
  // If the property doesn't exists, set it
  dataLayer[name] = value;
}
function processKeyLegacy(dataLayer, name, value, mergeable) {
  if (!Array.isArray(dataLayer.var_in_conflict)) {
    dataLayer.var_in_conflict = [];
  }
  // if "mergeable" attribute isn't false (undefined case), set mergeable on true
  mergeable = mergeable !== false;
  if (Array.isArray(value)) {
    // Define the property as array if not already set
    dataLayer[name] = dataLayer[name] || [];
    switch (name) {
      case "cdl_added_products":
      case "added_products":
        // AddToCart case, if we are on add to cart page AND products can be added with add to cart popin, 2 added_products keys are found in the DOM (the first is from addToCart page, the second is from popin).
        // To prevent the module from creating double added_product value in the datalayer, only the last key is added
        dataLayer[name] = value;
        utilities_1.console.warn('Specific property in data layer fragment must use "merge" attribute', {
          name,
          value
        });
        break;
      case "cdl_products":
      case "product_table":
        // If key is cdl_products or product_table, merge properties
        if (mergeable) {
          value.forEach((item, index) => {
            dataLayer[name][index] = dataLayer[name][index] || {};
            Object.assign(dataLayer[name][index], item);
          });
        }
        utilities_1.console.warn('Specific property in data layer fragment must use "merge" attribute', {
          name,
          value
        });
        break;
      default:
        if (mergeable || dataLayer[name].length === 0) {
          // All mergeable values from Array having same key are concatenated
          dataLayer[name].push(...value);
        } else {
          // Or replaced
          dataLayer[name] = value;
        }
        break;
    }
    return;
  }
  if (dataLayer[name]) {
    // Not an array, if the property already exists, we have a conflict
    dataLayer.var_in_conflict.push({
      keyName: name,
      keyValue: value,
      isMergeable: mergeable
    });
    return;
  }
  // Not an array, if the property doesn't exists, set it
  dataLayer[name] = value;
}
function build(dataLayerFragments) {
  return new Promise(resolve => {
    const dataLayer = {};
    // Variable that will contain the conflicts encountered (duplicates, ie: hard-coded values still present in the .ftl of the component sending the event)
    dataLayerFragments.forEach(fragment => {
      fragment.forEach(({
        name,
        value,
        mergeable,
        merge
      }) => {
        if (mergeable) {
          utilities_1.console.warn('Deprecated attribute "mergeable". Use "merge" instead', {
            name,
            value
          });
        }
        if (merge !== undefined) {
          processKey(dataLayer, name, value, merge);
        } else {
          processKeyLegacy(dataLayer, name, value, mergeable);
        }
      });
    });
    return resolve(Object.assign({
      cdl_environment_bot: /bot|crawler|crawling|spider/i.test(window.navigator.userAgent) ? "bot" : "customer"
    }, dataLayer));
  });
}